
import 'select2'; // Import Select2

document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('.js-select-categorized');
    let title = $('.js-select-categorized').data('title')

    // Initialize Select2 for each select element
    selects.forEach(select => {
        $(select).select2({
            placeholder: title,
            allowClear: false,
            width: '100%',
            templateResult: option => formatOption(option),
            templateSelection: option => formatOption(option),
            escapeMarkup: markup => markup // Prevent escaping HTML
        });

        // Handle selection change for each select
        select.addEventListener('change', e => {
            const selectedValues = Array.from(e.target.selectedOptions).map(option => option.value);
            console.log(`Selected values for ${e.target.name}:`, selectedValues);
            // Add custom logic here (e.g., form submission, redirect)
        });
    });

});




// Custom formatting for options
const formatOption = option => {
    if (!option.element) {
        return option.text;
    }

    const isOptgroup = option.element.tagName === 'OPTGROUP';
    if (isOptgroup) {
        const level = option.element.getAttribute('data-level') || '0';
        // Apply data-level to the main li for category group
        return $(`<div class="group-level-${level}">${option.text}</div>`);
    }

    // For options (tests), get the parent optgroup's data-level
    const parentOptgroup = option.element.closest('optgroup');
    const level = parentOptgroup ? parentOptgroup.getAttribute('data-level') || '0' : '0';

    return $(`<div class="group-level-${level}">${option.text}</span>`);
};
